import type * as React from 'react';
import styled from 'styled-components';

import { useViewerData } from '@xing-com/hub';
import {
  zIndexElevatedLayer5,
  mediaConfined,
  mediaTopBarVisible,
} from '@xing-com/layout-tokens';
import { Menu } from '@xing-com/menu';
import { MeMenuDropdownList } from '@xing-com/platform-layout-me-menu';
import { usePopOver } from '@xing-com/pop-over';
import { ProfileImage } from '@xing-com/profile-image';
import { ProgressBadge } from '@xing-com/progress-badge';
import { scale430, spaceXL, scale170 } from '@xing-com/tokens';

export const ProfileImageMeMenuContainer = styled.div`
  position: relative;
`;

export const StyledMeMenu = styled(Menu)`
  width: ${scale430};
  overflow: auto;
  right: 0;

  && {
    padding: ${spaceXL};
    z-index: ${zIndexElevatedLayer5};
  }

  @media ${mediaConfined} {
    max-height: calc(100vh - 60px);
  }

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const StyledProfileImageWrapper = styled.div`
  align-items: center;
  display: flex;
  height: ${scale170};
  justify-content: center;
`;

export const MeMenuDropdown: React.FC = () => {
  const viewerData = useViewerData();
  const profileImageUrl = (viewerData?.data?.user?.profileImage ?? [])[0]?.url;
  const networkEfficiencyIndicator =
    viewerData?.data?.networkEfficiencyIndicator || {};

  const { score, userTypeSupported } = networkEfficiencyIndicator;
  const showProfileFillingIndicator = userTypeSupported && score && score !== 1;

  const popOver = usePopOver();

  return (
    <ProfileImageMeMenuContainer
      onMouseLeave={popOver.handleHide}
      onMouseEnter={popOver.handleShow}
    >
      <StyledProfileImageWrapper>
        <ProfileImage
          data-testid="header-profile-logo"
          src={profileImageUrl}
          size="small"
          onClick={popOver.togglePopOver}
          progressBadge={
            showProfileFillingIndicator ? (
              <ProgressBadge
                progress={Math.round(score * 100)}
                data-testid="top-bar-profile-progress-badge"
              />
            ) : null
          }
        />
      </StyledProfileImageWrapper>
      <StyledMeMenu
        data-testid="me-menu-dropdown"
        onOutsideClick={popOver.handleHide}
        show={popOver.show}
        isInFlow
        isStatic
        triggerRef={popOver.triggerRef}
      >
        <MeMenuDropdownList closeModal={popOver.handleHide} />
      </StyledMeMenu>
    </ProfileImageMeMenuContainer>
  );
};
